import { MobileOrderFg } from "types";

/**
 * 고객센터 정보
 */
export const CUSTOMER_SERVICE_CENTER = {
  [MobileOrderFg.WMPO]: "(위메프오 고객센터 1833-4877)",
  [MobileOrderFg.DDANGYO]: "(땡겨요 고객센터 1661-5489)",
  [MobileOrderFg.BMSMILE]: "(위글루션 고객센터 1533-8266)",
  [MobileOrderFg.OLTTEA_AH]: "(올때아아 고객센터 1577-3059)",
  [MobileOrderFg.YOGIYO_EXPRESS]: "(요기요 고객센터 1661-5270)",
  [MobileOrderFg.HUNGRY_PANDA]: "(헝그리판다 고객센터 02-3700-5124)",
  [MobileOrderFg.PANDA_SELF_DELIVERY]: "(헝그리판다 고객센터 02-3700-5124)",
};
